import { HEX_000000, HEX_292D38, HEX_CED7E2, HEX_FFFFFF } from '@tanium/colors';
import { getRgbString } from '@tanium/coreui-utils';
import { defineColor, defineThemeValue, Overlay1 } from '@tanium/react-theme-definition';

export const Border = defineColor([HEX_CED7E2, 'transparent']);
export const Fill = defineColor([HEX_FFFFFF, HEX_000000]);
export const FillWithAlpha = (alpha?: string) =>
  defineColor([HEX_FFFFFF, getRgbString(HEX_000000, alpha)]);
export const Text = defineColor([HEX_292D38, HEX_FFFFFF]);
export const Shadow = Overlay1;
export const BackdropFilter = defineThemeValue([undefined, 'blur(10px)']);

// The arrow needs to overlap the main tooltip border in light mode, but
// in dark mode it should NOT overlap.
export const ArrowPlacement = defineThemeValue(['-4px', '-5px']);
